const { default: getConfig } = require('next/config');

const {
	publicRuntimeConfig: { env, baseUrl, assetPrefix }
} = getConfig();

export const imagePrefix = (env === 'development'
	? assetPrefix
	: `${baseUrl}${assetPrefix}`
).replace('www.', '');

export const getRatioImage = (image) => {
	const { width, height } = image;

	return width && height ? (height / width) * 100 : null;
};
